import { API_BASE, type ApiResponse } from "./api";

export interface UploadedFile {
  id: string;
  originalName: string;
  contentType: string;
  sizeBytes: number;
}

async function upload(path: string, file: File, purpose: string): Promise<UploadedFile> {
  const form = new FormData();
  form.append("purpose", purpose);
  form.append("file", file);
  const response = await fetch(`${API_BASE}${path}`, {
    method: "POST",
    credentials: "include",
    headers: { "X-CalWalk-Request": "web" },
    body: form,
  });
  const payload = (await response.json().catch(() => null)) as ApiResponse<UploadedFile> | null;
  if (!response.ok || !payload?.ok) throw new Error(payload?.message || "파일을 업로드하지 못했습니다.");
  return payload.data;
}

export const uploadMemberFile = (file: File, purpose: "ORDER_ATTACHMENT" | "PROFILE_IMAGE" | "SUPPLEMENT_ATTACHMENT") => upload("/files", file, purpose);
export const uploadAdminFile = (file: File, purpose: "WORKER_PHOTO" | "WORKER_CERTIFICATE" | "COMPLETION_DOCUMENT" | "COMPLETION_PHOTO" | "QUOTE_ATTACHMENT") => upload("/admin/files", file, purpose);

export async function downloadStoredFile(id: string, originalName: string, admin = false) {
  return downloadFile(`${admin ? "/admin" : ""}/files/${encodeURIComponent(id)}`, originalName);
}

export async function downloadFile(path: string, originalName: string) {
  const response = await fetch(`${API_BASE}${path}`, { credentials: "include" });
  if (!response.ok) throw new Error("파일을 다운로드하지 못했습니다.");
  const url = URL.createObjectURL(await response.blob());
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = originalName;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export async function deleteStoredFile(id: string, admin = false) {
  const response = await fetch(`${API_BASE}${admin ? "/admin" : ""}/files/${encodeURIComponent(id)}`, {
    method: "DELETE",
    credentials: "include",
    headers: { "X-CalWalk-Request": "web" },
  });
  if (!response.ok) throw new Error("파일을 삭제하지 못했습니다.");
}

export const adminFileUrl = (id: string) => `${API_BASE}/admin/files/${encodeURIComponent(id)}`;

export async function loadMemberFileUrl(id: string) {
  const response = await fetch(`${API_BASE}/files/${encodeURIComponent(id)}`, { credentials: "include" });
  if (!response.ok) throw new Error("파일을 불러오지 못했습니다.");
  return URL.createObjectURL(await response.blob());
}
